import { render, staticRenderFns } from "./binds.vue?vue&type=template&id=1dcc1400&scoped=true&"
import script from "./binds.vue?vue&type=script&lang=js&"
export * from "./binds.vue?vue&type=script&lang=js&"
import style0 from "./binds.vue?vue&type=style&index=0&id=1dcc1400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc1400",
  null
  
)

export default component.exports